module.exports = __webpack_public_path__ + "img/etiquetado.820874f0.jpg";